import { getActiveRegionConfig } from '@/lib/regionConfig';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const regionConfig = getActiveRegionConfig();

  const handlePlaceholderLink = (e, label) => {
    e.preventDefault();
  };

  return (
    <footer className="border-t border-border bg-card mt-auto">
      <div className="px-6 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-sm text-muted-foreground">
            &copy; {currentYear} The Digital Reports Company Limited. All rights reserved.
          </div>

          <div className="flex items-center gap-6 text-sm">
            <a href="#privacy" onClick={(e) => handlePlaceholderLink(e, 'Privacy Policy')} className="text-muted-foreground hover:text-foreground transition-colors">
              Privacy Policy
            </a>
            <a href="#terms" onClick={(e) => handlePlaceholderLink(e, 'Terms of Service')} className="text-muted-foreground hover:text-foreground transition-colors">
              Terms of Service
            </a>
            <a href={`mailto:${regionConfig.supportEmail}`} className="text-muted-foreground hover:text-foreground transition-colors">
              Contact Support
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
